/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Pre-Pulse
  
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

const getters = {
  GetTaskList : state => {
    return state.taskList
  },
  GetIncidents : state => {
    return state.incidents
  },
  GetCurrentIncidentID : state => {
    return state.currentIncidentID
  },
  GetCallList : state => {
    return state.callList
  },
  GetAttachedFiles : state => {
    return state.attachedFiles
  },
  GetFileUploadSettings : state => {
    return state.fileUploadSettings
  },
  GetFileUploadQueue : state => {
    return state.fileUploadQueue
  },
  GetIncidentNotes : state => {
    return state.incidentNotes
  },
  GetClaimLossPayments : state => {
    return state.claimLossPayments
  },
  GetClaimSearch : state => {
    return state.claimSearch
  },
  GetClaimSearchMax : state => {
    return state.claimSearchMax
  },
}

export default getters
